import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef
} from "@angular/core";
import { Column } from "./kanban-column/kanban-column.component";

@Component({
    selector: "app-driveb-kanban",
    templateUrl: "./kanban.component.html",
    styleUrls: ["./kanban.component.scss"],
    standalone: false
})
export class KanbanComponent implements OnInit {
  @Input() columns: Column[];
  @Input() cardTemplate: TemplateRef<any>;
  @Output() reachedEndColumn = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}
}
